import { render, staticRenderFns } from "./triagecalculation.vue?vue&type=template&id=12934d22"
import script from "./triagecalculation.vue?vue&type=script&lang=ts"
export * from "./triagecalculation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports